import React from "react";
import { Navbar } from "../components/Navbar";
import { PageHeader } from "../components/PageHeader";
import { Services } from "../components/Services";
import { Marquee } from "../components/Marquee";
import { CtaBanner } from "../components/CtaBanner";
import { Footer } from "../components/Footer";
import { useLang } from "../i18n/LanguageContext";
import { productImages } from "../data/images";

export default function ServicesPage() {
  const { t, lang } = useLang();
  return (
    <main className="bg-[#F9F8F6] text-[#1A1A1A] font-body" data-testid="page-services">
      <Navbar transparentOnHome={false} />
      <PageHeader
        eyebrow={t("services.eyebrow")}
        title={t("services.title")}
        subtitle={
          lang === "de"
            ? "Von der ersten Skizze bis zur Übergabe — alles aus einer Hand."
            : "From first sketch to final handover — everything from one team."
        }
        image={productImages.design}
      />
      <Services hideHeader />
      <Marquee />
      <CtaBanner variant="dark" />
      <Footer />
    </main>
  );
}
